import { Typography, withStyles } from "@material-ui/core";
import MuiTableCell from "@material-ui/core/TableCell";
import MuiTableRow from "@material-ui/core/TableRow";
import { Select } from "@ofqual/portal-components/components/Select";
import React from "react";
import { ApprovalStatusSelectOptions } from "../../../../domain/ApprovalStatusSelectOptions";
import { ApprovalStatus } from "../../../../domain/ApprovalSubject";
import { TeachingActivity } from "../../../../domain/SubjectModel";
import {
  IEvaluationApprovalCardProps,
  handleSetApprovalSubject,
} from "../utils";

const TABLE_CELL_WIDTH: string = "50%";

const TableCell = withStyles({
  root: {
    borderBottom: "none",
    padding: "2px",
  },
})(MuiTableCell);

const TableRow = withStyles({
  root: {
    padding: 0,
  },
})(MuiTableRow);

export const TeachingApprovalCard: React.FC<IEvaluationApprovalCardProps> = ({
  subject,
  matchingLevel,
  approvalSubjects,
  setApprovalSubjects,
  dataTest,
  readOnly
}) => {
  const approvalSubject = approvalSubjects.find(
    (s) => s.subjectId === subject.id
  );

  return (
    <>
      {!!(subject.teachingActivity & TeachingActivity.TeachingOrLecturing) && (
        <>
          <TableRow>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Typography variant="subtitle1">Teaching or lecturing</Typography>
            </TableCell>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Select
                size="small"
                value={
                  approvalSubject?.levels.find(
                    (l) => l.levelId === matchingLevel.id
                  )?.evaluationResults!.teachingLecturingAssessment
                    ?.approvalStatus
                }
                onChange={(e) =>
                  handleSetApprovalSubject(
                    subject.id,
                    matchingLevel.id,
                    "teachingLecturingAssessment",
                    e.target.value as unknown as ApprovalStatus,
                    approvalSubjects,
                    setApprovalSubjects
                  )
                }
                data-test={`teaching-lecturing-assessment-${dataTest}`}
                readOnly={readOnly}
                label={""}
              >
                {ApprovalStatusSelectOptions()}
              </Select>
            </TableCell>
          </TableRow>
        </>
      )}
      {!!(subject.teachingActivity & TeachingActivity.Training) && (
        <>
          <TableRow>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Typography variant="subtitle1">Training</Typography>
            </TableCell>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Select
                size="small"
                value={
                  approvalSubject?.levels.find(
                    (l) => l.levelId === matchingLevel.id
                  )?.evaluationResults!.trainingAssessment?.approvalStatus
                }
                onChange={(e) =>
                  handleSetApprovalSubject(
                    subject.id,
                    matchingLevel.id,
                    "trainingAssessment",
                    e.target.value as unknown as ApprovalStatus,
                    approvalSubjects,
                    setApprovalSubjects
                  )
                }
                data-test={`training-assessment-${dataTest}`}
                readOnly={readOnly}
                label={""}
              >
                {ApprovalStatusSelectOptions()}
              </Select>
            </TableCell>
          </TableRow>
        </>
      )}
      {!!(
        subject.teachingActivity & TeachingActivity.EducationalManagement
      ) && (
        <>
          <TableRow>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Typography variant="subtitle1">
                Educational management
              </Typography>
            </TableCell>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Select
                size="small"
                value={
                  approvalSubject?.levels.find(
                    (l) => l.levelId === matchingLevel.id
                  )?.evaluationResults!.educationManagementAssessment
                    ?.approvalStatus
                }
                onChange={(e) =>
                  handleSetApprovalSubject(
                    subject.id,
                    matchingLevel.id,
                    "educationManagementAssessment",
                    e.target.value as unknown as ApprovalStatus,
                    approvalSubjects,
                    setApprovalSubjects
                  )
                }
                data-test={`education-management-assessment-${dataTest}`}
                readOnly={readOnly}
                label={""}
              >
                {ApprovalStatusSelectOptions()}
              </Select>
            </TableCell>
          </TableRow>
        </>
      )}
      {!!(subject.teachingActivity & TeachingActivity.TeacherTraining) && (
        <>
          <TableRow>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Typography variant="subtitle1">Teacher training</Typography>
            </TableCell>
            <TableCell component="th" scope="row" width={TABLE_CELL_WIDTH}>
              <Select
                size="small"
                value={
                  approvalSubject?.levels.find(
                    (l) => l.levelId === matchingLevel.id
                  )?.evaluationResults!.teacherTrainingAssessment
                    ?.approvalStatus
                }
                onChange={(e) =>
                  handleSetApprovalSubject(
                    subject.id,
                    matchingLevel.id,
                    "teacherTrainingAssessment",
                    e.target.value as unknown as ApprovalStatus,
                    approvalSubjects,
                    setApprovalSubjects
                  )
                }
                data-test={`teacher-training-assessment-${dataTest}`}
                readOnly={readOnly}
                label={""}
              >
                {ApprovalStatusSelectOptions()}
              </Select>
            </TableCell>
          </TableRow>
        </>
      )}
      <TableRow>
        <TableCell colSpan={2}>&nbsp;</TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={2}>
          <hr />
        </TableCell>
      </TableRow>
    </>
  );
};
